import ClienteRetail from "./ClienteRetail";

export default ClienteRetail;
